// extracted by mini-css-extract-plugin
export default {"formWrapper":"i5SMsD8qmdsZb8G4AW1o","submitWrapper":"IwE09N45QF9HvVWfnMjj","submitButton":"DRyDYlNlxtEyfo1WbGpS","disabled":"l_9Ive4IqTpXzDTgOiaD"};